


































import {Component, Prop, Vue} from 'vue-property-decorator'
import {uniqueId} from "@/util/uniqueId";
import {getExifOrientation} from "@/util/files";

export interface FileInfo {
    name: string;
    uri: string;
    type: string;
    file?: File | null;
}

@Component
export default class FileInput extends Vue {
    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: true
    })
    isEnabled!: boolean;

    @Prop()
    label!: string;

    @Prop()
    error?: string | null;

    @Prop({
        default: null
    })
    existingFileInfo!: FileInfo | null;

    private fileInfo: FileInfo | null = this.existingFileInfo;

    async receiveFile(event: InputEvent) {
        const inputElement = event.target as HTMLInputElement;
        const files = inputElement.files;

        if (files && files.length > 0) {
            const file = files[0];
            this.fileInfo = {
                name: file.name,
                uri: await this.processFileToDataUri(file),
                type: file.type,
                file: file
            };

            if (file.type.includes('image')) {
                this.$nextTick(async () => {
                    const imgElement = document.getElementById(`file-input-preview-${this.uid}`) as HTMLImageElement;
                    const imageOrientation = window.getComputedStyle(imgElement).imageOrientation;
                    if (imageOrientation === 'from-image') {
                        // ImageOrientation style is set - do not auto configure
                        return;
                    }

                    const exifOrientation = await getExifOrientation(file);

                    if (imgElement.style)

                        switch (exifOrientation) {
                            case 6:
                                imgElement.style.transform = 'rotate(90deg)';
                                break;
                            case 8:
                                imgElement.style.transform = 'rotate(-90deg)';
                                break;
                            case 3:
                                imgElement.style.transform = 'rotate(180deg)';
                                break;
                            default:
                                imgElement.style.transform = '';

                        }
                });

            }

            this.$emit('update:file', this.fileInfo.file);
        }
    }

    removeFile() {
        this.fileInfo = null;
        this.$emit('update:file', null);
    }

    private async processFileToDataUri(file: File): Promise<string> {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result as string);
            };

            reader.readAsDataURL(file);
        });
    }

    private get iconName(): string | null {
        if (!this.fileInfo?.type) {
            return null;
        }

        const type = this.fileInfo.type;
        if (type.includes('image')) {
            return 'file-image';
        } else if (type.includes('pdf')) {
            return 'file-pdf';
        } else if (type.includes('sheet')) {
            return 'file-excel';
        } else {
            return 'file';
        }
    }

    private uid = uniqueId();
}
